/*
 * @Date         : 2021-03-17 16:13:53
 * @LastEditors  : zhangxu
 * @LastEditTime : 2021-04-06 21:54:23
 * @FilePath     : /mvp/src/shared/storage.ts
 */
class Storage {
  get(key: string, isLocal = true) {
    let value = ''
    if (isLocal) {
      value = localStorage.getItem(key) || ''
    } else {
      value = sessionStorage.getItem(key) || ''
    }
    try {
      if (!value) return value
      return JSON.parse(value)
    } catch (e) {
      return value
    }
  }

  set(key: string, value: any, isLocal = true) {
    if (typeof value === 'undefined' || value === null) return
    try {
      value = JSON.stringify(value) || value
    } catch (e) {
    }
    if (isLocal) {
      localStorage.setItem(key, value)
    } else {
      sessionStorage.setItem(key, value)
    }
  }

  delete(key: string, isLocal = true) {
    if (isLocal) {
      localStorage.removeItem(key)
    } else {
      sessionStorage.removeItem(key)
    }
  }
}
export default new Storage()
